import './ManualInput.css';
import cx from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import { Stack } from '../../components/Stack/Stack';
import { Icon } from '../../components/Icon/Icon';
import { t } from '../../locales/translate';

interface Props {
  onCodeSubmit: ({ code, clearInput }: { code: string; clearInput: () => void }) => void;
  isInputInvalid: boolean;
  isInView: boolean;
}

const INPUT_NAME = 'code';

export function ManualInput({ onCodeSubmit, isInputInvalid, isInView }: Props): JSX.Element {
  const [inputValue, setInputValue] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);

  const containerRef = useRef<HTMLFormElement>(null);

  const clearInput = (): void => {
    setInputValue('');
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>): void => {
    e.preventDefault();
    onCodeSubmit({ code: e.target[INPUT_NAME].value, clearInput });
  };

  const handleInput = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setInputValue(e.target.value);
  };

  useEffect(() => {
    if (isInView) {
      inputRef.current?.focus();
    } else {
      inputRef.current?.blur();
      clearInput();
    }
  }, [isInView]);

  return (
    <form className="manual-input" onSubmit={handleSubmit} ref={containerRef}>
      <Stack size="lg">
        <Stack>
          <h2 className="manual-input__title">{t.page.ticketScanner.enterTicketNumber}</h2>
          <div className="manual-input__input-wrapper">
            <input
              ref={inputRef}
              onBlur={() => {
                document.documentElement.scrollTop = 0;
              }}
              value={inputValue}
              onChange={handleInput}
              autoFocus={false}
              name={INPUT_NAME}
              className={cx('manual-input__input', {
                'manual-input__input--error': isInputInvalid,
              })}
              required
            />
            <span
              className="manual-input__input-icon"
              onClick={(e) => {
                e.preventDefault();
                clearInput();
              }}
            >
              <Icon name="cross--transparent" />
            </span>
          </div>
        </Stack>
        <button
          type="submit"
          className={cx('manual-input__button', { 'manual-input__button--disabled': inputValue.length === 0 })}
          disabled={inputValue.length === 0}
        >
          {t.page.ticketScanner.submit}
        </button>
      </Stack>
    </form>
  );
}
